import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const FilesUploadIcon = ({ width = 14, height = 14, color: colorProp, fill: fillProp }: IconProps) => {
  const { defaultColor } = useDefaultIconsColor();
  const color = colorProp || defaultColor;

  return (
    <svg
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
          d="M7 12.6129C7.42759 12.6129 7.77422 12.2663 7.77422 11.8387C7.77422 11.4111 7.42759 11.0645 7 11.0645C6.5724 11.0645 6.22577 11.4111 6.22577 11.8387C6.22577 12.2663 6.5724 12.6129 7 12.6129Z"
          stroke={color}
          stroke-width="0.8"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
            d="M6.99998 4.87061C7.4258 4.87061 7.76453 5.21901 7.74517 5.64483L7.6 9.5208C7.59033 9.84501 7.32419 10.1015 6.99998 10.1015C6.67577 10.1015 6.40963 9.84501 6.39995 9.5208L6.25478 5.64483C6.24027 5.21901 6.57899 4.87061 6.99998 4.87061Z"
            stroke={color}
            stroke-width="0.8"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.58691 11.8388H12.1486C12.8019 11.8388 13.2132 11.1178 12.8841 10.5371L7.73551 1.82222C7.40647 1.24155 6.59353 1.24155 6.26449 1.82222L1.11588 10.5371C0.786831 11.1178 1.19814 11.8388 1.85139 11.8388H4.43871"
            stroke={color}
            stroke-width="0.8"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
  );
};
